import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const feature = {
  fetchFeatures: lazyModuleMethod(() => import('./fetchFeatures'), 'default'),
  fetchFeature: lazyModuleMethod(() => import('./fetchFeature'), 'default'),
  createFeature: lazyModuleMethod(() => import('./createFeature'), 'default'),
  updateFeature: lazyModuleMethod(() => import('./updateFeature'), 'default'),
  deleteFeature: lazyModuleMethod(() => import('./deleteFeature'), 'default'),
}
